import DOMPurify from 'dompurify';

/**
 * Sanitiser for HTML that ends up in `dangerouslySetInnerHTML` (richtext and
 * callout blocks, lesson text in the player). Allows the inline markup the
 * editor produces plus common formatting; strips scripts, handlers and
 * `javascript:` URLs.
 */
export function sanitizeHtml(html: string): string {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form', 'input'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick', 'style'],
        ADD_ATTR: ['target', 'rel'],
    });
}
